import { AxiosInstance } from 'axios';
import { RequestArgs } from 'generated/base';
import { instanceApi } from 'utils/axios';

const createRequestUrl = (
  axiosArgs: RequestArgs,
  globalAxios: AxiosInstance = instanceApi,
): string => {
  const csrfToken = globalAxios.defaults.headers.common['X-CSRF-Token'];
  let url = `${globalAxios.defaults.baseURL}${axiosArgs.url}`;

  if (csrfToken) {
    const csrfTokenParam = `csrf-token=${csrfToken}`;
    url = `${url}${url.includes('?') ? `&${csrfTokenParam}` : `?${csrfTokenParam}`}`;
  }
  return url;
};

export default createRequestUrl;
